import { render, staticRenderFns } from "./Merchants.vue?vue&type=template&id=d2e0d03a"
import script from "./Merchants.vue?vue&type=script&lang=js"
export * from "./Merchants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports